import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useParams } from 'react-router-dom';
import { JobOfferTemplateManagement } from '@modules/JobOfferTemplates';

const ContainerWrapper = styled(Box)(({ theme }) => ({
    borderRadius: '24px',
    background: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    flex: 1,
}));

const CompanyJobOfferTemplates = () => {
    const { id } = useParams<{ id: string }>();

    return (
        <ContainerWrapper>
            <JobOfferTemplateManagement proId={id} />
        </ContainerWrapper>
    );
};

export default CompanyJobOfferTemplates;
